/* Paw Baby (Paws style) quick add + tabs. Uses Craft's cart notification/drawer when present. */
(() => {
  if (window.pawCardInit) return;
  window.pawCardInit = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-paw-quick-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = new FormData(form);
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map((section) => section.id));
      body.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const state = await response.json();

      if (state.status) {
        window.alert(state.description || state.message || window.cartStrings?.error);
        return;
      }
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'paw-card', productVariantId: body.get('id'), cartData: state });
      }
      cart.renderContents(state);

      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 2000);
    } catch (error) {
      window.location = window.routes.cart_url;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  /* Tabs: [data-paw-tabs] > [role=tab][aria-controls] + [role=tabpanel] */
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-paw-tabs] [role="tab"]');
    if (!tab) return;
    selectTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-paw-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = tabs.length - 1;
    event.preventDefault();
    tabs[index].focus();
    selectTab(tabs[index]);
  });

  function selectTab(tab) {
    const root = tab.closest('[data-paw-tabs]');
    root.querySelectorAll('[role="tab"]').forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', selected);
      other.tabIndex = selected ? 0 : -1;
      root.querySelector(`#${other.getAttribute('aria-controls')}`).hidden = !selected;
    });
    const link = root.querySelector('[data-paw-view-all]');
    if (link && tab.dataset.url) link.href = tab.dataset.url;
  }
})();
